import React from 'react';
import './MetricCard.css';
import { formatIndianCurrency } from '../../../utils/currencyFormatter';

const MetricCard = ({ 
  title, 
  value, 
  unit = '', 
  change, 
  changeLabel = 'vs last period',
  icon, 
  trend = [],
  target,
  subtitle,
  size = 'medium',
  colorScheme = 'blue',
  onClick
}) => {
  const isPositive = change >= 0;
  const hasTarget = target !== undefined && target !== null;
  const progress = hasTarget ? Math.min((value / target) * 100, 100) : null;

  const formatValue = (val) => {
    if (unit === '₹' && typeof val === 'number') {
      return formatIndianCurrency(val, false, 1);
    }
    if (typeof val === 'number' && val >= 1000) {
      return val.toLocaleString('en-IN');
    }
    return val;
  };

  const renderSparkline = () => {
    if (!trend || trend.length === 0) return null;

    const max = Math.max(...trend);
    const min = Math.min(...trend);
    const range = max - min || 1;

    const points = trend.map((val, idx) => {
      const x = (idx / (trend.length - 1)) * 100;
      const y = 100 - ((val - min) / range) * 100;
      return `${x},${y}`;
    }).join(' ');

    return (
      <svg className="metric-card-sparkline" viewBox="0 0 100 100" preserveAspectRatio="none">
        <polyline
          points={points}
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        />
      </svg>
    );
  };

  return (
    <div 
      className={`metric-card metric-card-${size} metric-card-${colorScheme} ${onClick ? 'metric-card-clickable' : ''}`}
      onClick={onClick}
    >
      <div className="metric-card-header">
        <div className="metric-card-title">
          {icon && <span className="metric-card-icon">{icon}</span>}
          <span>{title}</span>
        </div>
        {change !== undefined && change !== null && (
          <div className={`metric-card-change ${isPositive ? 'positive' : 'negative'}`}>
            <span className="change-arrow">{isPositive ? '↑' : '↓'}</span>
            <span className="change-value">{Math.abs(change)}%</span>
          </div>
        )}
      </div>

      <div className="metric-card-body">
        <div className="metric-card-value">
          {unit === '₹' && <span className="metric-card-unit">{unit}</span>}
          {formatValue(value)}
          {unit && unit !== '₹' && <span className="metric-card-unit">{unit}</span>}
        </div>

        {subtitle && (
          <div className="metric-card-subtitle">{subtitle}</div>
        )}

        {change !== undefined && change !== null && (
          <div className="metric-card-change-label">{changeLabel}</div>
        )}
      </div>

      {trend && trend.length > 0 && (
        <div className="metric-card-trend">
          {renderSparkline()}
        </div>
      )}

      {hasTarget && (
        <div className="metric-card-progress">
          <div className="progress-bar">
            <div 
              className="progress-fill" 
              style={{ width: `${progress}%` }}
            />
          </div>
          <div className="progress-label">
            {unit === '₹' ? '₹' : ''}{formatValue(value)} / {unit === '₹' ? '₹' : ''}{formatValue(target)} ({progress.toFixed(0)}%)
          </div>
        </div>
      )}
    </div>
  );
};

export default MetricCard;

